module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/error505/error505.component.css
// module id = ./src/app/components/error505/error505.component.css
// module chunks = main